import React, { useContext } from 'react';
import itaFlag from "./../assets/ItalianFlag.png";
import engFlag from "./../assets/UkFlag.png";



export function Navigation({ data,onLanguageChange }) { 
  const handleLanguageChange = (lang) => {
    onLanguageChange(lang); // Pass language to the parent component
  };
  return (
    <nav id="menu" className="navbar navbar-default navbar-fixed-top">
      <div className="container">
        <div className="navbar-header">
          <button
            type="button"
            className="navbar-toggle collapsed"
            data-toggle="collapse"
            data-target="#bs-example-navbar-collapse-1"
          >
            {" "}
            <span className="sr-only">Toggle navigation</span>{" "}
            <span className="icon-bar"></span>{" "}
            <span className="icon-bar"></span>{" "}
            <span className="icon-bar"></span>{" "}
          </button>
          <a className="navbar-brand page-scroll" href="#page-top">
            GK Consulting
          </a>{" "}
        </div>

        <div
          className="collapse navbar-collapse"
          id="bs-example-navbar-collapse-1"
        >
          <ul className="nav navbar-nav navbar-right">
        
            <li>
              <a href="#features" className="page-scroll">
                Industries
              </a>
            </li>
            <li>
              <a href="#services" className="page-scroll">
                E-platform
              </a>
            </li>
            <li style={{ display: 'none' }}>
              <a href="#portfolio" className="page-scroll">
              {data ? data.clienti : "Loading"}
                
              </a>
            </li>
          
            <li>
              <a href="#contact" className="page-scroll">
              {data ? data.contatti : "Loading"}
              </a>
            </li>
            <li>
              <a href="#" className="flag-link">
                <img src={itaFlag}  alt="Italian Flag" className="flag" onClick={() => handleLanguageChange('italian')}/>
              </a>
            </li>
            <li>
              <a href="#" className="flag-link">
                <img src={engFlag} alt="English Flag" className="flag" onClick={() => handleLanguageChange('english')}/>
              </a>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
};
